module.exports = __webpack_public_path__ + "img/how-to-navigate-3.8dfc9007.jpg";